var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 71,
    viewBox: "0 0 89 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81433 70.5146C6.39039 70.5146 4.31535 69.6516 2.58921 67.9254C0.86307 66.1993 0 64.1243 0 61.7003V8.81433C0 6.39039 0.86307 4.31535 2.58921 2.58921C4.31535 0.86307 6.39039 0 8.81433 0H79.329C81.7529 0 83.828 0.86307 85.5541 2.58921C87.2802 4.31535 88.1433 6.39039 88.1433 8.81433V61.7003C88.1433 64.1243 87.2802 66.1993 85.5541 67.9254C83.828 69.6516 81.7529 70.5146 79.329 70.5146H8.81433ZM44.0717 39.6645L8.81433 17.6287V61.7003H79.329V17.6287L44.0717 39.6645ZM44.0717 30.8502L79.329 8.81433H8.81433L44.0717 30.8502ZM8.81433 17.6287V8.81433V61.7003V17.6287Z",
    fill: "#D8DDE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.e4a5151d1c21bbe5b546ef28ca167981.svg";
export { ForwardRef as ReactComponent };